import ApplicationDetailsLayoutContainer from "../../components/applications/ApplicationDetailsLayoutContainer";
import ApplicationProvider, { useApplicationContext } from "../../contexts/ApplicationContext";
import ContestCategoriesProvider from "../../contexts/ContestCategoriesContext";
import ContestProvider from "../../contexts/ContestContext";
import PresentationsProvider from "../../contexts/PresentationsContext";
import { Grid } from "@mui/material";
import { Outlet, useParams } from "react-router-dom";
import { useApplication } from "../../hooks/useApplication";
import { useContest } from "../../hooks/useContest";
import { useContestCategories } from "../../hooks/useContestCategories";
import { usePresentations } from "../../hooks/usePresentations";

// Wydzielony komponent dla czytelności, z dostępem do contextu zgłoszenia.
// Jest to niezbędne dla prawidłowego działania pobierania danych zgłoszenia.
function ApplicationContent() {
  const { application } = useApplicationContext();
  const { contest } = useContest(application?.contestId as string);
  const { categories } = useContestCategories(application?.contestId as string);
  const {
    presentations,
    isLoading: presentationsLoading,
    handlePresentationAdd,
    handlePresentationUpdate,
    handlePresentationDelete,
    handleSoloPresentationsBatch,
  } = usePresentations({ applicationId: application?.id });

  return (
    <>
      {contest && (
        <ContestProvider contest={contest}>
          {categories && (
            <ContestCategoriesProvider categories={categories}>
              <PresentationsProvider
                presentations={presentations}
                isLoading={presentationsLoading}
                handlePresentationAdd={handlePresentationAdd}
                handlePresentationUpdate={handlePresentationUpdate}
                handlePresentationDelete={handlePresentationDelete}
                handleSoloPresentationsBatch={handleSoloPresentationsBatch}
              >
                <ApplicationDetailsLayoutContainer>
                  <Outlet />
                </ApplicationDetailsLayoutContainer>
              </PresentationsProvider>
            </ContestCategoriesProvider>
          )}
        </ContestProvider>
      )}
    </>
  );
}

export default function ApplicationRoot() {
  const { applicationId } = useParams();
  const { application, refreshApplication, handleApplicationUpdate, updateApplicationStatus } =
    useApplication(applicationId as string);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        {application && (
          <ApplicationProvider
            application={application}
            updateApplication={handleApplicationUpdate}
            refreshApplication={refreshApplication}
            updateApplicationStatus={updateApplicationStatus}
          >
            <ApplicationContent />
          </ApplicationProvider>
        )}
      </Grid>
    </Grid>
  );
}
